var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--hexagon", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "hexagon-container" }, [
      _c("li", { staticClass: "hexagon hex_1" }),
      _vm._v(" "),
      _c("li", { staticClass: "hexagon hex_2" }),
      _vm._v(" "),
      _c("li", { staticClass: "hexagon hex_3" }),
      _vm._v(" "),
      _c("li", { staticClass: "hexagon hex_4" }),
      _vm._v(" "),
      _c("li", { staticClass: "hexagon hex_5" }),
      _vm._v(" "),
      _c("li", { staticClass: "hexagon hex_6" }),
      _vm._v(" "),
      _c("li", { staticClass: "hexagon hex_7" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }